var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaterMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 61,
    viewBox: "0 0 68 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.705 25.383C8.65821 36.5538 7.64614 47.8273 10.9981 53.2111C14.3501 58.5948 24.4822 67.9735 49.2456 52.5585C74.0089 37.1435 68.1762 19.6739 64.4913 13.7518C47.2328 -13.9735 -10.6091 5.6001 1.705 25.383Z",
    fill: "#EDF3FC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterMark);
export default __webpack_public_path__ + "static/media/waterMark.afb61b81e9dd6b76dccc28a891cbe01e.svg";
export { ForwardRef as ReactComponent };